import React from "react";
import "./Partlisttextfield.scss";
import { useTranslation } from "react-i18next";


const PartslistTextField = ({filterSearch , handelVehiclelistChange , handleChange , Vehiclename , searchVehicle}) => {

  const { i18n, t } = useTranslation();

  return (
    <div>
      <div className="pgmlistdropdown_textfield">
        <div className="div_flex">
          <div className="partlistdropdowndiv">
            <div className="input-wrapper inpu-wrapper">
              <label htmlFor="search">{t('partlist.search')}</label>
              <input className="partlistdropdowndiv_input" name="searchVehicle"  type="text" placeholder={t('partlist.entervalue')} value={searchVehicle} onChange={handleChange} />
            </div>
          </div>
        <button disabled={!searchVehicle} className="button_search_part" onClick={() => filterSearch(searchVehicle, Vehiclename)}> {t('partlist.search')}</button>
        </div>
      </div>
    </div>
  );
};

export default PartslistTextField;
